const tableList = (l) => {
  let maxColCount = 2
  let rowArr = []
  let i = 0

  while (i < l.length) {
    let j = 0
    let r = ""
    while ((j < maxColCount) && (i < l.length)) {
      r += `<td style="min-width:100px">${l[i]}</td>`
      i += 1
      j += 1
    }
    rowArr.push(`<tr>${r}</tr>`)
  }

  return rowArr.join("\n")
}

export const generateCode = (p) => {
  try {
    var genCode = `
      <meta content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width" />
      <title>Timetec24 | product</title>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        media="all"
      />
      <link
        rel="stylesheet"
        href="https://templates.timetec24.de/2017-threendy/css/all_v2.css"
        media="all"
      />

      <div align="center">
        <img
          src="https://timetec24.de/Turbo-Regeneration.gif"
          style="margin-bottom: 20px"
          alt="Turboregeneration"
          width="100%"
        />
      </div>
      <header id="header" class="wrapper">
        <div class="container">
          <div class="header-top">
            <div id="search_box">
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh"
                class="search-link"
              ></a>
              <span class="text">Suche</span>
              <span class="search_btn"
                ><i class="fa fa-search" aria-hidden="true"></i
              ></span>
            </div>
            <ul class="list-top">
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                  >eBay Shop</a
                >
              </li>
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                  >Über uns</a
                >
              </li>
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                  >Impressum</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="head-bg">
          <div class="container">
            <div class="header-main">
              <strong class="logo"
                ><a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/logo.png"
                    alt="TT24-logo" /></a
              ></strong>
              <ul class="list-icons">
                <li>
                  <i class="fa fa-truck" aria-hidden="true"></i
                  ><strong>Schneller Versand</strong>
                </li>
                <li>
                  <i class="fa fa-repeat" aria-hidden="true"></i
                  ><strong>1 Monat Widerrufsrecht</strong>
                </li>
                <li>
                  <i class="fa fa-trophy" aria-hidden="true"></i
                  ><strong>Top Qualität</strong>
                </li>
              </ul>
            </div>
            <nav id="nav">
              <input type="checkbox" id="open-menu" class="open-check" />
              <div class="hold-toogle">
                <label for="open-menu" class="toogle-menu">
                  Menü
                  <span class="t"></span>
                  <span class="c"></span>
                  <span class="b"></span>
                </label>
              </div>
              <div class="menu-holder">
                <label for="open-menu" class="close-menu">Menü schließen</label>
                <ul id="topnav">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Reparatur/_i.html?store_cat=1961154013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Turbolader - <br />Reparatur
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Generaluberholt/_i.html?store_cat=1961153013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Turbolader - <br />Generalüberholt
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Neu/_i.html?store_cat=2587581013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Turbolader - NEU </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Ladedruck - <br />Steller </span>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Unterdruckdose-Neu/_i.html?store_cat=9576403013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Unterdruckdose </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Rumpfgruppe-Neu/_i.html?store_cat=9577386013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Rumpfgruppe </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Abgaskrummer-Neu/_i.html?store_cat=9721511013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Abgaskrümmer </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Dichtungssatz-Montagesatz/_i.html?store_cat=27333212013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Dichtungssatz / <br />Montagesatz
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Kompressor-Neu/_i.html?store_cat=42169669013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Kompressor </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/DPF-Diesel-Partikel-Filter/_i.html?store_cat=49900671013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            DPF Diesel- <br />Partikel-Filter
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.ebay.de/str/timetec24gmbh/Sonstiges/_i.html?store_cat=1"
                    >
                      <div class="text-center">
                        <div class="text-inner">
                          <div class="text-last">Sonstige</div>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <label for="open-menu" class="overlay"></label>
            </nav>
          </div>
        </div>
      </header>
      <section id="main" class="wrapper">
        <div class="container">
          <input
            type="checkbox"
            class="open-check open-modal"
            id="modal"
            name="modal"
          />
          <div class="product-box">
            <div class="product-description">
              <h1>
                ${p.name}
              </h1>
              <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                ><strong class="warranty">Zur persönlichen Beratung</strong></a
              >
            </div>
            <div class="product-images">
              <input
                type="radio"
                class="open-check1"
                id="gallery01"
                name="gallery"
                checked="checked"
              />
              <div class="fade-gallery">
                ${p.imgLinks.map((i) => (`
                    <span class="empty-marker">
                      ${i}
                    </span>`
    ))
      }

                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery01"
                  name="fade-gallery"
                  checked="checked"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery02"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery03"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery04"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery05"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery06"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery07"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery08"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery09"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery10"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery11"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery12"
                  name="fade-gallery"
                />
                <div class="holder-img">
                  ${p.imgLinks.map((i) => (`
                      <img src="${i}" alt="image"/>`
      ))
      }

                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <label for="modal">
                    <span>Zum Vergrößern klicken</span>
                    <span class="close"
                      ><i class="fa fa-times" aria-hidden="true"></i
                    ></span>
                  </label>
                </div>
                <div class="switcher">
                ${p.imgLinks.map((i) => (`
                    <div class="thumbnail">
                      <label for="fade-gallery01">
                        <img
                        src="${i}"
                        alt="image"/>
                      </label>
                    </div>`
      ))
      }

                  <div class="thumbnail">
                    <label for="fade-gallery06"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery07"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery08"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery09"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery10"><img src="" alt="image" /></label>
                  </div>
                  <div class="holder-prev">
                    <label class="prev" for="fade-gallery01"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery02"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery03"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery04"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery05"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery06"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery07"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery08"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery09"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery10"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery11"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery12"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                  </div>
                  <div class="holder-next">
                    <label class="next" for="fade-gallery01"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery02"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery03"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery04"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery05"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery06"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery07"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery08"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery09"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery10"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery11"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery12"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-bottom">
            <div class="box-right">
              <strong class="price">${p.price}</strong>
              <span class="addition-grey">(inkl. MwSt.)</span>
              <ul class="pay-list">
                <li>
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/pay01.png"
                    alt="image"
                  />
                </li>
                <li>
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/pay02.png"
                    alt="image"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="main-box">
            <div class="lblock">
              <ul class="info-list">
                <li>Fachbetrieb für</li>
                <li>Turbotechnik mit</li>
                <li>eigener Werkstatt</li>
              </ul>
            </div>
            <div class="rblock">
              <p>▀▄▀▄▀▄ XPRESS-Versand bei NACHFRAGE bis 15 Uhr ▄▀▄▀▄▀</p>
            </div>
          </div>

          <div vocab="https://schema.org/" typeof="Product">
            <div
              class="Teilenummer-vergleichen"
              style="float: left; width: 420px; margin-bottom: 20px"
            >
              <img
                src="https://timetec24.de/animation.gif"
                alt="Teilenummer-vergleichen"
              />
            </div>
            <div class="Teilenummer-vergleichen">
              <strong
                >Liebe Kunden,<br />
                bitte haben Sie Verständnis dafür, dass es bei den vielen tausend
                Teilenummern auch mal zu Fehlern kommen kann. <br />
                Wir haften daher nicht für Inkompatibilitäten und damit verbundene
                Ausfälle oder Kosten, sollte mal ein Artikel auch an Hand der
                Teilnummer nicht passen.<br />
                Planen Sie daher sicherheitshalber ein zeitliches Puffer ein, falls
                der Artikel getauscht oder zurückgegeben werden muss.</strong
              >
            </div>
            <div class="Teilenummer-vergleichen" style="clear: left"></div>
            <div class="prod-box">
              <div class="title-block">
                <h2>Artikeldetails</h2>
                <span>Passend z.B. für folgende Fahrzeuge</span>
              </div>
              <ul class="prod-list">
                ${p.cars.map(c => {
        let mc = c.models.map(m => (
          `<li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        ${m}
                    </li>`
        )).join("\n")

        return `
                  <li>
                    <div class="img-holder">
                      <figure>
                        <img src="https://timetec24.de/kfzlogos/${c.brand}.jpg" alt="${c.brand}" />
                      </figure>
                    </div>
                    <div class="inf-holder">
                      <ul class="mark-list">
                        ${mc}
                      </ul>
                    </div>
                  </li>
                  `
      }).join("\n")}
              </ul>
            </div>
            <div class="tab-box">
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">OE-TEILENUMMERN</th>
                    </tr>
                    ${p.partNums.map(pn => (
        `<tr>
                      <td>${pn}</td>
                    </tr>`
      )).join("\n")}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="2">VERGLEICHSNUMMERN</th>
                    </tr>
                    ${p.compNums.map(cn => (
        `<tr>
                      <td>${cn}</td>
                    </tr>`
      )).join("\n")}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">MOTOR</th>
                    </tr>
                    ${p.motors.map(m => (
        `<tr>
                      <td>${m}</td>
                    </tr>`
      )).join("\n")}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">LEISTUNG</th>
                    </tr>
                    ${p.performance.map(pr => (
        `<tr>
                      <td>${pr}</td>
                    </tr>`
      )).join("\n")}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">MOTORCODE</th>
                    </tr>
                    ${p.motorCodes.map(mc => (
        `<tr>
                      <td>${mc}</td>
                    </tr>`
      )).join("\n")}
                  </tbody>
                </table>
              </div>
            </div>

            <p style="font-size: 150%">
              <strong>${p.nDeposit}</strong>
            </p>
            <p>
              <span style="color: #ff0000"
                ><strong>${p.nHeader}</strong></span
              >
            </p>
            <ul style="list-style: disc"></ul>
            <ul>
              ${p.nList.map(nl => (
        `<li>${nl}</li>`
      )).join("\n")}
            </ul>
            <p>
              <span style="color: #ff0000"
                ><strong
                  >${p.nFooter}</strong
                ></span
              >
            </p>

            <div class="inf-box">
              <div class="fbox">
                <figure>
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/coil.jpg"
                    alt="image"
                  />
                </figure>
              </div>
              <div class="sbox">
                <p>
                  <strong>Unser Service beginnt schon vor dem Kauf!</strong>
                </p>
                <p>
                  Kontaktieren Sie uns daher bei Interesse an unserem Produkt und wir
                  garantieren eine erstklassige Beratung und Klärung aller Fragen. So
                  kommen keine Missverständnisse auf.
                </p>
                <p>
                  Wir verschicken die Ware, wenn verfügbar, innerhalb von 24 Stunden,
                  frühestens jedoch nach abgeschlossenem Zahlungseingang. Mit der Ware
                  erhalten Sie auch die Rechnung mit ausgewiesener MwSt. Die Kaution
                  erhalten Sie binnen 14 Tagen zurück, sobald Ihr Altteil vollständig
                  bei uns mitsamt Kontodaten oder PayPal-Infos eingegangen ist.
                  Bezüglich der Verfügbarkeit können Sie gerne mit uns in Kontakt
                  treten.
                </p>
              </div>
            </div>
          </div>
          <div class="cont-box">
            <div class="container">
              <h2>Kontakt &amp; Support</h2>
              <div class="left">
                <div class="box">
                  <div class="block">
                    <p>Bei Fragen zu unseren</p>
                    <p>Artikeln nehmen Sie bitte</p>
                    <p>Kontakt auf</p>
                  </div>
                  <div class="block help">
                    <p>Sie finden nicht das passende Teil?</p>
                    <strong>Wir helfen Ihnen gern telefonisch!</strong>
                  </div>
                </div>
                <div class="box">
                  <div class="block">
                    <ul class="icon-list">
                      <li>
                        <i class="fa fa-truck" aria-hidden="true"></i>
                        Schneller Versand
                      </li>
                      <li>
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        Vertraulicher Umgang
                      </li>
                      <li>
                        <i class="fa fa-paypal" aria-hidden="true"></i>
                        Zahlen per PayPal
                      </li>
                    </ul>
                  </div>
                  <div class="block">
                    <ul class="icon-list">
                      <li>
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        Express-Versand (+29,90 EUR)<br /><br />
                        <strong
                          >WICHTIG: unbedingt telefonisch die Verfügbarkeit
                          erfragen</strong
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="right">
                <figure class="img-holder">
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/logo-big.png"
                    alt="TT24-logo"
                  />
                </figure>
              </div>
            </div>
          </div>
          <div class="container">
            <h2>Katalog</h2>
            <ul class="single">
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Reparatur/_i.html?store_cat=1961154013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img01.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Turbolader - Reparatur</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Generaluberholt/_i.html?store_cat=1961153013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img02.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand"
                            >Turbolader - Generalüberholt</strong
                          >
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Neu/_i.html?store_cat=2587581013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img03.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Turbolader</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img04.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Ladedruck - Steller</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img05.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Elektronik - Reparatur</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Unterdruckdose-Neu/_i.html?store_cat=9576403013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img06.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Unterdruckdose</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Rumpfgruppe-Neu/_i.html?store_cat=9577386013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img07.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Rumpfgruppe</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Abgaskrummer-Neu/_i.html?store_cat=9721511013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img08.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Abgaskrümmer</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Dichtungssatz-Montagesatz/_i.html?store_cat=27333212013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img09.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand"
                            >Dichtungssatz / Montagesatz</strong
                          >
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Kompressor-Neu/_i.html?store_cat=42169669013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img10.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Kompressor</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/DPF-Diesel-Partikel-Filter/_i.html?store_cat=49900671013"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img11.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand"
                            >DPF Diesel-Partikel-Filter</strong
                          >
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.ebay.de/str/timetec24gmbh/Sonstiges/_i.html?store_cat=1"
                  class="brand-link"
                >
                  <span class="hold-img"
                    ><img
                      src="https://templates.timetec24.de/2017-threendy/images/img12.jpg"
                      alt="image"
                  /></span>
                  <span class="text-wrap">
                    <span class="text-center">
                      <span class="text-inner">
                        <span class="text-last">
                          <strong class="title-brand">Sonstige</strong>
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <footer id="footer" class="wrapper">
        <div class="container">
          <div class="box-holder">
            <div class="box">
              <ul class="info-list">
                <li>
                  <strong class="title">Öffnungszeiten Ladengeschäft:</strong>
                  <span class="inform"></span>
                  <span class="inform second"></span>
                  <figure class="img-holder">
                    <img
                      src="https://templates.timetec24.de/2017-threendy/images/footer-car.png"
                      alt="Car"
                    />
                  </figure>
                </li>
              </ul>
            </div>
            <div class="box">
              <ul class="info-list">
                <li>
                  <ul class="link-list">
                    <li>
                      <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                        >eBay Shop</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.ebay.de/str/timetec24gmbh#tab1"
                        >Über uns</a
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="copy">
                    <p>© 2022 TimeTec24 GmbH</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    `
    return genCode
  } catch (err) {
    console.log(p.sku, ": ", err)
    throw new Error("HTML code generation failed for product: ", p.sku)
  }

}

export const generateCode1 = (p) => {
  try {
    var genCode = `
    <meta content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width" />
      <title>Timetec24 | product</title>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        media="all"
      />
      <link
        rel="stylesheet"
        href="https://templates.timetec24.de/2017-threendy/css/all_v3.css"
        media="all"
      />

      <div align="center">
        <video width="100%" margin-bottom="20px" preload="metadata" controls>
          <source src="https://timetec24.de/Erkl%c3%a4r-Video-2024/Kurz-E-V-co.mp4" />
        </video>
      </div>
      <header id="header" class="wrapper">
        <div class="container">
          <div class="header-top">
            <div id="search_box">
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh"
                class="search-link"
              ></a>
              <span class="text">Suche</span>
              <span class="search_btn"
                ><i class="fa fa-search" aria-hidden="true"></i
              ></span>
            </div>
            <ul class="list-top">
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                  >eBay Shop</a
                >
              </li>
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                  >Über uns</a
                >
              </li>
              <li>
                <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                  >Impressum</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="head-bg">
          <video
            playsinline="playsinline"
            autoplay="autoplay"
            loop="loop"
            muted="muted"
            width="100%"
            height="100%"
            preload="metadata"
            poster="//turbolader24.com/cdn/shop/files/preview_images/slider-home_small.webp?v=1753802275"
          >
            <source
              src="//turbolader24.com/cdn/shop/videos/c/vp/3a6eb3598dd34400ab0e063c297d0deb/3a6eb3598dd34400ab0e063c297d0deb.HD-1080p-3.3Mbps-48305181.mp4?v=0"
              type="video/mp4"
            />
            <img
              src="//turbolader24.com/cdn/shop/files/preview_images/slider-home_small.webp?v=1753802275"
            />
          </video>

          <div class="container">
            <div class="header-main">
              <strong class="logo"
                ><a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/logo.png"
                    alt="TT24-logo" /></a
              ></strong>
              <ul class="list-icons">
                <li>
                  <i class="fa fa-truck" aria-hidden="true"></i
                  ><strong>Schneller Versand</strong>
                </li>
                <li>
                  <i class="fa fa-repeat" aria-hidden="true"></i
                  ><strong>1 Monat Widerrufsrecht</strong>
                </li>
                <li>
                  <i class="fa fa-trophy" aria-hidden="true"></i
                  ><strong>Top Qualität</strong>
                </li>
              </ul>
            </div>

            <div class="content-section">
              <p class="sub-title">Seit 2008 Ihr Spezialist für Turbolader</p>
              <h2 class="section-header">
                <strong
                  >Neue & regenerierte Turbolader sowie Ersatzteile – direkt vom
                  Fachbetrieb.</strong
                >
              </h2>
              <div class="section-description">
                <p>
                  TimeTec24 steht für geprüfte Originalqualität, fachgerechte
                  Aufbereitung und zuverlässigen Service – so, wie Sie es aus der
                  Erstausrüstung kennen.
                </p>
              </div>
            </div>
            <div
              id="shopify-section-template--25604815520009__manufacturers_logo_JggTxR"
              class="shopify-section"
            >
              <link
                href="//turbolader24.com/cdn/shop/t/4/assets/manufacturers-logo.css?v=22889808025259971321753241597"
                rel="stylesheet"
                type="text/css"
                media="all"
              />

              <style data-shopify="">
                #shopify-section-template--25604815520009__manufacturers_logo_JggTxR
                  .manufacturers-logo {
                  background-color: transparent;
                }
              </style>
              <div class="manufacturers-logo">
                <div class="page-width">
                  <div class="manufacturers-logo-wrapper swiper-main-wrapper">
                    <div
                      class="swiper swiper-initialized swiper-horizontal swiper-pointer-events"
                      data-slider-options='{ "slidesPerView": 3,
                    "loop": false,"centeredSlides": false, 
                    "direction":"horizontal",
                    "navigation":{
                    "nextEl":"#shopify-section-template--25604815520009__manufacturers_logo_JggTxR .swiper-button-next",
                    "prevEl":"#shopify-section-template--25604815520009__manufacturers_logo_JggTxR .swiper-button-prev"
                    },
                      "pagination":{
                          "el":"#shopify-section-template--25604815520009__manufacturers_logo_JggTxR .swiper-pagination",
                          "clickable":true
                      },
                    "keyboard":{
                    "enabled":true,
                    "onlyInViewport":true
                    },
                    "effect":"slide",
                    "speed":1500,
                    "breakpoints": { 
                      "275": { "slidesPerView": 3.5,  "spaceBetween":20,"centeredSlides": true},
                      "600": { "slidesPerView": 5,  "spaceBetween":20},
                      "800": { "slidesPerView": 6,  "spaceBetween":20},
                      "990": { "slidesPerView": 8,  "spaceBetween": 20},
                      "1200": { "slidesPerView": 11,  "spaceBetween": 10}
                    } }'
                    >
                      <div
                        class="swiper-wrapper"
                        id="swiper-wrapper-f28ea7a97e6218a3"
                        aria-live="polite"
                        style="transform: translate3d(0px, 0px, 0px)"
                      >
                        <div
                          class="manufacturers-logo-item swiper-slide swiper-slide-active"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="1 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image1"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide swiper-slide-next"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="2 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image2"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="3 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image3"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="4 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image4"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="5 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image5"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="6 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image6"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="7 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image7"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="8 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image8"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="9 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image9"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="10 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image10"></div>
                            </a>
                          </div>
                        </div>
                        <div
                          class="manufacturers-logo-item swiper-slide"
                          style="width: 109.091px; margin-right: 10px"
                          role="group"
                          aria-label="11 / 11"
                        >
                          <div class="manufacturers-logo-item-inner">
                            <a href="#" class="logo-link">
                              <div class="logo-image image11"></div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <span
                        class="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <nav id="nav">
              <input type="checkbox" id="open-menu" class="open-check" />
              <div class="hold-toogle">
                <label for="open-menu" class="toogle-menu">
                  Menü
                  <span class="t"></span>
                  <span class="c"></span>
                  <span class="b"></span>
                </label>
              </div>
              <div class="menu-holder">
                <label for="open-menu" class="close-menu">Menü schließen</label>
                <ul id="topnav">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Reparatur/_i.html?store_cat=1961154013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Turbolader - <br />Reparatur
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Generaluberholt/_i.html?store_cat=1961153013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Turbolader - <br />Generalüberholt
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Neu/_i.html?store_cat=2587581013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Turbolader - NEU </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Ladedruck - <br />Steller </span>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Unterdruckdose-Neu/_i.html?store_cat=9576403013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Unterdruckdose </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Rumpfgruppe-Neu/_i.html?store_cat=9577386013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Rumpfgruppe </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Abgaskrummer-Neu/_i.html?store_cat=9721511013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Abgaskrümmer </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Dichtungssatz-Montagesatz/_i.html?store_cat=27333212013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            Dichtungssatz / <br />Montagesatz
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/Kompressor-Neu/_i.html?store_cat=42169669013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last"> Kompressor </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.ebay.de/str/timetec24gmbh/DPF-Diesel-Partikel-Filter/_i.html?store_cat=49900671013"
                    >
                      <span class="text-center">
                        <span class="text-inner">
                          <span class="text-last">
                            DPF Diesel- <br />Partikel-Filter
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.ebay.de/str/timetec24gmbh/Sonstiges/_i.html?store_cat=1"
                    >
                      <div class="text-center">
                        <div class="text-inner">
                          <div class="text-last">Sonstige</div>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <label for="open-menu" class="overlay"></label>
            </nav>
          </div>
        </div>
      </header>
      <section id="main" class="wrapper">
        <div class="container">
          <input
            type="checkbox"
            class="open-check open-modal"
            id="modal"
            name="modal"
          />
          <div class="product-box">
            <div class="product-description">
              <h1>
                ${p.name}
              </h1>
              <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh#tab1"
                ><strong class="warranty">Zur persönlichen Beratung</strong></a
              >
            </div>
            <div class="product-images">
              <input
                type="radio"
                class="open-check1"
                id="gallery01"
                name="gallery"
                checked="checked"
              />
              <div class="fade-gallery">
                ${p.imgLinks.map((i) => (`
                    <span class="empty-marker">
                      ${i}
                    </span>`
    ))
      }
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <span class="empty-marker"></span>
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery01"
                  name="fade-gallery"
                  checked="checked"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery02"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery03"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery04"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery05"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery06"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery07"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery08"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery09"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery10"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery11"
                  name="fade-gallery"
                />
                <input
                  type="radio"
                  class="open-check"
                  id="fade-gallery12"
                  name="fade-gallery"
                />
                <div class="holder-img">
                  ${p.imgLinks.map((i) => (`
                      <img src="${i}" alt="image"/>`
      ))
      }
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <img src="" alt="image" />
                  <label for="modal">
                    <span>Zum Vergrößern klicken</span>
                    <span class="close"
                      ><i class="fa fa-times" aria-hidden="true"></i
                    ></span>
                  </label>
                </div>
                <div class="switcher">
                  ${p.imgLinks.map((i) => (`
                    <div class="thumbnail">
                      <label for="fade-gallery01">
                        <img
                        src="${i}"
                        alt="image"/>
                      </label>
                    </div>`
      ))
      }
                  <div class="thumbnail">
                    <label for="fade-gallery06"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery07"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery08"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery09"><img src="" alt="image" /></label>
                  </div>
                  <div class="thumbnail">
                    <label for="fade-gallery10"><img src="" alt="image" /></label>
                  </div>
                  <div class="holder-prev">
                    <label class="prev" for="fade-gallery01"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery02"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery03"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery04"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery05"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery06"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery07"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery08"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery09"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery10"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery11"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                    <label class="prev" for="fade-gallery12"
                      ><i class="fa fa-arrow-left" aria-hidden="true"></i
                    ></label>
                  </div>
                  <div class="holder-next">
                    <label class="next" for="fade-gallery01"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery02"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery03"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery04"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery05"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery06"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery07"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery08"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery09"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery10"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery11"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                    <label class="next" for="fade-gallery12"
                      ><i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-bottom">
            <div class="box-right">
              <strong class="price">${p.price}</strong>
              <span class="addition-grey">(inkl. MwSt.)</span>
              <ul class="pay-list">
                <li>
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/pay01.png"
                    alt="image"
                  />
                </li>
                <li>
                  <img
                    src="https://templates.timetec24.de/2017-threendy/images/pay02.png"
                    alt="image"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="main-box">
            <div class="lblock">
              <ul class="info-list">
                <li>Fachbetrieb für</li>
                <li>Turbotechnik mit</li>
                <li>eigener Werkstatt</li>
              </ul>
            </div>
            <div class="rblock">
              <p>▀▄▀▄▀▄ XPRESS-Versand bei NACHFRAGE bis 15 Uhr ▄▀▄▀▄▀</p>
            </div>
          </div>

          <div vocab="https://schema.org/" typeof="Product">
            <div
              class="Teilenummer-vergleichen"
              style="float: left; width: 420px; margin-bottom: 20px"
            >
              <img
                src="https://timetec24.de/animation.gif"
                alt="Teilenummer-vergleichen"
              />
            </div>
            <div class="Teilenummer-vergleichen">
              <strong
                >Liebe Kunden,<br />
                bitte haben Sie Verständnis dafür, dass es bei den vielen tausend
                Teilenummern auch mal zu Fehlern kommen kann. <br />
                Wir haften daher nicht für Inkompatibilitäten und damit verbundene
                Ausfälle oder Kosten, sollte mal ein Artikel auch an Hand der
                Teilnummer nicht passen.<br />
                Planen Sie daher sicherheitshalber ein zeitliches Puffer ein, falls
                der Artikel getauscht oder zurückgegeben werden muss.</strong
              >
            </div>
            <div class="Teilenummer-vergleichen" style="clear: left"></div>
            <div class="prod-box">
              <div class="title-block">
                <h2>Artikeldetails</h2>
                <span>Passend z.B. für folgende Fahrzeuge</span>
              </div>
              <ul class="prod-list">
                ${p.cars.map(c => {
        let mc = c.models.map(m => (
          `<li>
                          <i class="fa fa-check" aria-hidden="true"></i>
                          ${m}
                        </li>`
        )).join("\n")

        return `
                    <li>
                      <div class="img-holder">
                      <figure>
                        <img src="https://timetec24.de/kfzlogos/${c.brand}.jpg" alt="${c.brand}" />
                      </figure>
                      </div>
                      <div class="inf-holder">
                        <ul class="mark-list">
                          ${mc}
                        </ul>
                      </div>
                    </li>
                    `
      }).join("\n")}
              </ul>
            </div>
            <div class="tab-box">
              <div class="holder">
                <table class="twintab">
                  <tbody>
                    <tr>
                      <th colspan="2">OE-TEILENUMMERN</th>
                    </tr>
                    ${tableList(p.partNums)}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="2">VERGLEICHSNUMMERN</th>
                    </tr>
                    ${tableList(p.compNums)}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="2">MOTOR</th>
                    </tr>
                    ${tableList(p.motors)}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">LEISTUNG</th>
                    </tr>
                    ${tableList(p.performance)}
                  </tbody>
                </table>
              </div>
              <div class="holder">
                <table class="onetab">
                  <tbody>
                    <tr>
                      <th colspan="1">MOTORCODE</th>
                    </tr>
                    ${tableList(p.motorCodes)}
                  </tbody>
                </table>
              </div>
            </div>
            <div align="center">
              <p style="font-size: 150%">
                <strong>${p.nDeposit}</strong>
              </p>
              <p>
                <span style="color: #ff0000"
                  ><strong
                    >${p.nHeader}</strong
                  ></span
                >
              </p>
              <ul style="list-style: disc"></ul>
              <ul>
                ${p.nList.map(nl => (
        `<li>${nl}</li>`
      )).join("\n")}
              </ul>
              <p>
                <span style="color: #ff0000"
                  ><strong
                    >${p.nFooter}</strong
                  ></span
                >
              </p>
            </div>
          </div>
          <div class="inf-box">
            <div class="fbox">
              <figure>
                <img
                  src="https://templates.timetec24.de/2017-threendy/images/coil.jpg"
                  alt="image"
                />
              </figure>
            </div>
            <div class="sbox">
              <p>
                <strong>Unser Service beginnt schon vor dem Kauf!</strong>
              </p>
              <p>
                Kontaktieren Sie uns daher bei Interesse an unserem Produkt und wir
                garantieren eine erstklassige Beratung und Klärung aller Fragen. So
                kommen keine Missverständnisse auf.
              </p>
              <p>
                Wir verschicken die Ware, wenn verfügbar, innerhalb von 24 Stunden,
                frühestens jedoch nach abgeschlossenem Zahlungseingang. Mit der Ware
                erhalten Sie auch die Rechnung mit ausgewiesener MwSt. Die Kaution
                erhalten Sie binnen 14 Tagen zurück, sobald Ihr Altteil vollständig
                bei uns mitsamt Kontodaten oder PayPal-Infos eingegangen ist.
                Bezüglich der Verfügbarkeit können Sie gerne mit uns in Kontakt
                treten.
              </p>
            </div>
          </div>
        </div>
        <div class="cont-box">
          <div class="container">
            <h2>Kontakt &amp; Support</h2>
            <div class="left">
              <div class="box">
                <div class="block">
                  <p>Bei Fragen zu unseren</p>
                  <p>Artikeln nehmen Sie bitte</p>
                  <p>Kontakt auf</p>
                </div>
                <div class="block help">
                  <p>Sie finden nicht das passende Teil?</p>
                  <strong>Wir helfen Ihnen gern telefonisch!</strong>
                </div>
              </div>
              <div class="box">
                <div class="block">
                  <ul class="icon-list">
                    <li>
                      <i class="fa fa-truck" aria-hidden="true"></i>
                      Schneller Versand
                    </li>
                    <li>
                      <i class="fa fa-lock" aria-hidden="true"></i>
                      Vertraulicher Umgang
                    </li>
                    <li>
                      <i class="fa fa-paypal" aria-hidden="true"></i>
                      Zahlen per PayPal
                    </li>
                  </ul>
                </div>
                <div class="block">
                  <ul class="icon-list">
                    <li>
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      Express-Versand (+29,90 EUR)<br /><br />
                      <strong
                        >WICHTIG: unbedingt telefonisch die Verfügbarkeit
                        erfragen</strong
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="right">
              <figure class="img-holder">
                <img
                  src="https://templates.timetec24.de/2017-threendy/images/logo-big.png"
                  alt="TT24-logo"
                />
              </figure>
            </div>
          </div>
        </div>
        <div class="container">
          <h2>Katalog</h2>
          <ul class="single">
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Reparatur/_i.html?store_cat=1961154013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img01.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Turbolader - Reparatur</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Generaluberholt/_i.html?store_cat=1961153013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img02.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand"
                          >Turbolader - Generalüberholt</strong
                        >
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Turbolader-Neu/_i.html?store_cat=2587581013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img03.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Turbolader</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img04.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Ladedruck - Steller</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Elektronik-Neu/_i.html?store_cat=2848424013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img05.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Elektronik - Reparatur</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Unterdruckdose-Neu/_i.html?store_cat=9576403013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img06.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Unterdruckdose</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Rumpfgruppe-Neu/_i.html?store_cat=9577386013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img07.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Rumpfgruppe</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Abgaskrummer-Neu/_i.html?store_cat=9721511013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img08.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Abgaskrümmer</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Dichtungssatz-Montagesatz/_i.html?store_cat=27333212013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img09.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand"
                          >Dichtungssatz / Montagesatz</strong
                        >
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Kompressor-Neu/_i.html?store_cat=42169669013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img10.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Kompressor</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/DPF-Diesel-Partikel-Filter/_i.html?store_cat=49900671013"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img11.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand"
                          >DPF Diesel-Partikel-Filter</strong
                        >
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.ebay.de/str/timetec24gmbh/Sonstiges/_i.html?store_cat=1"
                class="brand-link"
              >
                <span class="hold-img"
                  ><img
                    src="https://templates.timetec24.de/2017-threendy/images/img12.jpg"
                    alt="image"
                /></span>
                <span class="text-wrap">
                  <span class="text-center">
                    <span class="text-inner">
                      <span class="text-last">
                        <strong class="title-brand">Sonstige</strong>
                      </span>
                    </span>
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </section>
      <footer id="footer" class="wrapper">
        <div class="container">
          <div class="box-holder">
            <div class="box">
              <ul class="info-list">
                <li>
                  <strong class="title">Öffnungszeiten Ladengeschäft:</strong>
                  <span class="inform"></span>
                  <span class="inform second"></span>
                  <figure class="img-holder">
                    <img
                      src="https://templates.timetec24.de/2017-threendy/images/footer-car.png"
                      alt="Car"
                    />
                  </figure>
                </li>
              </ul>
            </div>
            <div class="box">
              <ul class="info-list">
                <li>
                  <ul class="link-list">
                    <li>
                      <a target="_blank" href="https://www.ebay.de/str/timetec24gmbh"
                        >eBay Shop</a
                      >
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.ebay.de/str/timetec24gmbh#tab1"
                        >Über uns</a
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="copy">
                    <p>© 2022 TimeTec24 GmbH</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

    `

    return genCode
  } catch (err) {
    console.log(p.sku, ": ", err)
    throw new Error("HTML code generation failed for product: ", p.sku)
  }
}